import React from 'react';
import { useNavigate } from "react-router-dom";
import { TagCloud } from 'react-tagcloud';
import normatecaStore from '../../../stores/normatecaStore';

export default function MasConsultado(){
    const navigate= useNavigate();
    const {jsonMasConsultado} =
    normatecaStore((state) =>( { 
        jsonMasConsultado: state.jsonMasConsultado,
      })); 

    const cambiaContenido=(opcVis, indices)=>{
        navigate("/app/normateca/menu=" + opcVis + "_" + indices);
       }

    return(
        <div>
            <div className="divTit">
                <div className="titpublicRes">Lo más consultado por materia</div>
                <div className="linepublicRes"></div>
            </div>
            <div className="divloMC">
                <div className='tagCloudMC'>
                <TagCloud
                    className='txt-align-center'
                    minSize={12}
                    maxSize={40}
                    tags={jsonMasConsultado}
                    shuffle={false}
                    onClick={mat => cambiaContenido(mat.id,mat.inds)}
                />
                </div>
            </div>
        </div>
    )
}